<p-table
  styleClass="p-datatable-gridlines"
  [value]="atividadeEvents"
  [scrollable]="true"
  scrollHeight="400px"
  [loading]="loading"
  [sortField]="'data'"
  [sortOrder]="-1"
>
  <ng-template pTemplate="header">
    <tr [ngClass]="{ 'atividades-events-row': true }">
      <th>Status</th>
      <th pSortableColumn="data">Data Sincronismo<p-sortIcon field="data"></p-sortIcon></th>
      <th pSortableColumn="dataInicio">Data Início</th>
      <th>Data Fim</th>
      <th>Responsável</th>
      <th>Alteração</th>
      <th>Data Envio SICOM</th>
      <th>Mensagem SICOM</th>
      <th>Observação</th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-atividadeEvent>
    <tr [ngClass]="{ 'atividades-events-row': true }">
      <td [ngStyle]="{ color: '#' + atividadeEvent.cor + '' }">{{ atividadeEvent.nomeStatus }}</td>
      <td>{{ atividadeEvent.data | date : 'dd/MM/yyyy HH:mm:ss' }}</td>
      <td>{{ atividadeEvent.dataInicio | date : 'dd/MM/yyyy HH:mm:ss' }}</td>
      <td>{{ atividadeEvent.dataFim | date : 'dd/MM/yyyy HH:mm:ss' }}</td>
      <td>{{ atividadeEvent.tecnicoAlocado }}</td>
      <td>{{ atividadeEvent.funcionarioAlteracao }}</td>
      <td>{{ atividadeEvent.dataEnvioSicom | date : 'dd/MM/yyyy HH:mm:ss' }}</td>
      <td>{{ atividadeEvent.mensagemSicom }}</td>
      <td>{{ atividadeEvent.obs }}</td>
    </tr>
  </ng-template>
</p-table>
